module.exports = __webpack_public_path__ + "static/media/Remove-Snail.d910fad1.svg";